import { fetchApi } from '../client';

export interface NavRouteItem {
  id: string;
  path: string;
  label: string;
  icon: string | null;
  permissionCode: string | null;
  moduleCode: string | null;
  defaultRoles: string[];
  sortOrder: number;
}

export interface NavVisibilityRow {
  id: string;
  path: string;
  label: string;
  icon: string | null;
  permissionCode: string | null;
  moduleCode: string | null;
  defaultVisible: boolean;
  overrideVisible: boolean | null;  // null = no override
  effectiveVisible: boolean;
}

export const navRoutesModule = {
  // ── Super admin: route registry ───────────────────────────────────────────
  getAllRoutes: () =>
    fetchApi<NavRouteItem[]>('/api/admin/nav-routes'),

  updateRoute: (id: string, data: { label?: string; permissionCode?: string | null }) =>
    fetchApi<void>(`/api/admin/nav-routes/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    }),

  // ── Super admin: per-clinic visibility overrides ───────────────────────
  getClinicMatrix: (clinicId: string) =>
    fetchApi<Record<string, NavVisibilityRow[]>>(
      `/api/admin/nav-routes/clinic/${clinicId}/visibility`
    ),

  setClinicVisibility: (clinicId: string, roleCode: string, routeId: string, visible: boolean) =>
    fetchApi<void>(
      `/api/admin/nav-routes/clinic/${clinicId}/visibility/${roleCode}/${routeId}`,
      { method: 'PUT', body: JSON.stringify({ visible }) }
    ),

  resetClinicVisibility: (clinicId: string, roleCode: string, routeId: string) =>
    fetchApi<void>(
      `/api/admin/nav-routes/clinic/${clinicId}/visibility/${roleCode}/${routeId}`,
      { method: 'DELETE' }
    ),

  // ── Clinic admin: own clinic ───────────────────────────────────────────
  getMyClinicMatrix: () =>
    fetchApi<Record<string, NavVisibilityRow[]>>('/api/clinic/nav/visibility'),

  setMyClinicVisibility: (roleCode: string, routeId: string, visible: boolean) =>
    fetchApi<void>(`/api/clinic/nav/visibility/${roleCode}/${routeId}`, {
      method: 'PUT',
      body: JSON.stringify({ visible }),
    }),

  resetMyClinicVisibility: (roleCode: string, routeId: string) =>
    fetchApi<void>(`/api/clinic/nav/visibility/${roleCode}/${routeId}`, {
      method: 'DELETE',
    }),
};
